import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import EnterpriseITPage from "@/pages/service/EnterpriseITPage";

export const Route = createFileRoute("/service/enterprise-it")({
  head: () => pageHead("Enterprise IT Services", "AI-optimized infrastructure design, cloud solutions, and IT consulting for digital transformation.", "/service/enterprise-it", false),
  component: EnterpriseITPage,
});
